import { useCapitalGlobalProposalStep1Form } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.context';
import { CapitalGlobalProposalAddressFields } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-address-fields.component';
import { Switch, Text } from '@noorden-insurtech/alba-design-system';

export function CapitalGlobalProposalStipulantCorrespondenceSection() {
  const {
    form,
    isViewMode,
    onSameCorrespondenceChange,
    isLoadingCorrCep,
    hasResolvedCorrCep,
    canEditCorrStreetNeighborhood,
    zipcodeLookupCacheRef,
    fetchAndFillCorr,
    shouldShowStep1FieldErrors,
  } = useCapitalGlobalProposalStep1Form();

  return (
    <form.Subscribe
      selector={state => state.values.sameCorrespondenceAsRegistration}
      children={sameCorrespondenceAsRegistration => (
        <div className='flex flex-col gap-6'>
          <div className='flex flex-wrap items-center gap-3'>
            <Switch.Root
              checked={sameCorrespondenceAsRegistration}
              onCheckedChange={details =>
                onSameCorrespondenceChange(details.checked)
              }
              disabled={isViewMode}
            >
              <Switch.Control>
                <Switch.Thumb />
              </Switch.Control>
              <Switch.Label className='text-base text-alba-black-500'>
                Endereço de cadastro, é o mesmo de correspondência?
              </Switch.Label>
              <Switch.HiddenInput />
            </Switch.Root>
          </div>

          {!sameCorrespondenceAsRegistration ? (
            <div className='flex flex-col gap-4'>
              <Text className='text-base font-normal text-alba-black-500'>
                Endereço de correspondência
              </Text>
              <CapitalGlobalProposalAddressFields
                form={form}
                fieldPrefix='correspondence'
                isViewMode={isViewMode}
                isLoadingCep={isLoadingCorrCep}
                hasResolvedCep={hasResolvedCorrCep}
                canEditStreetNeighborhood={canEditCorrStreetNeighborhood}
                zipcodeLookupCacheRef={zipcodeLookupCacheRef}
                fetchAndFill={fetchAndFillCorr}
                shouldShowStep1FieldErrors={shouldShowStep1FieldErrors}
                hideUntilCepResolved
              />
            </div>
          ) : null}
        </div>
      )}
    />
  );
}
